import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {api} from '../lib/api';

const SHARDA_LOGO = "https://customer-assets.emergentagent.com/job_prodfabrix/artifacts/mi0mx8zz_image.png";

export default function StabilityLoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [freshStart, setFreshStart] = useState(false);
  const [workArchive, setWorkArchive] = useState(false);
  useEffect(() => {
    let cancelled = false;
    api.get('/api/fresh-start/status').then(({data}) => {
      if (!cancelled) {setFreshStart(data.mode === 'real' && data.status === 'Pending');setWorkArchive(data.mode === 'real' && data.work_archive_status === 'Pending');}
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isSubmitting) return;
    const submitted = new FormData(event.currentTarget);
    const submittedUsername = String(submitted.get('username') || '').trim();
    const submittedPassword = String(submitted.get('password') || '');
    if (!submittedUsername || !submittedPassword) {
      setError('Enter your username and password.');
      return;
    }
    setError("");
    setIsSubmitting(true);
    try {
      await login(submittedUsername, submittedPassword);
      navigate("/dashboard");
    } catch (requestError) {
      const detail = requestError.response?.data?.detail;
      setError(Array.isArray(detail) ? detail.map(d=>d.msg).join(' ') : String(detail || 'Invalid credentials.'));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-page" data-testid="stability-login-page">
      <div className="login-card" data-testid="stability-login-card">
        <div className="login-logo">
          <img src={SHARDA_LOGO} alt="Sharda Production" data-testid="login-brand-logo" />
          <h1 className="login-title" data-testid="login-title">Sharda Production</h1>
          <p className="login-subtitle">Manufacturing Command Center</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form" data-testid="stability-login-form">
          <div className="form-group">
            <label className="form-label" htmlFor="username-input">Username</label>
            <input
              id="username-input"
              name="username"
              required
              className="form-input"
              placeholder="Enter username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              data-testid="stability-username-input"
            />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="password-input">Password</label>
            <input
              id="password-input"
              name="password"
              required
              className="form-input"
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              data-testid="stability-password-input"
            />
          </div>

          {error && (
            <div className="login-error" data-testid="stability-login-error">{error}</div>
          )}
          {freshStart && <p role="status" data-testid="fresh-start-login-status" style={{fontSize:13, lineHeight:1.6}}>{isSubmitting ? 'Preparing the one-time fresh start. Please keep this page open.' : 'First owner sign-in: opening stock retained, purchases archived, active work cleared.'}</p>}
          {!freshStart&&workArchive&&<p role="status" data-testid="work-archive-login-status" style={{fontSize:13,lineHeight:1.6}}>{isSubmitting?'Checking sign-in and preparing the one-time work archive. Please keep this page open.':'Next Admin sign-in: old work and purchasing become history-only. Ready-stock balances, BOMs and accounts are retained. This happens once.'}</p>}

          <button className="btn-primary" type="submit" disabled={isSubmitting} data-testid="stability-login-submit-button" style={{ width: "100%", padding: "14px", fontSize: 14 }}>
            {isSubmitting ? (freshStart||workArchive ? 'PREPARING WORKSPACE…' : "AUTHENTICATING...") : "SIGN IN"}
          </button>
        </form>

        <div style={{ marginTop: 32, textAlign: "center", fontSize: 11, color: "hsl(var(--ink-muted))", fontFamily: "'JetBrains Mono', monospace" }}>
          v2.0 // SHARDA ERP SYSTEM
        </div>
      </div>
    </div>
  );
}
